<template>
	<inertia-head title="Stock Updates" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Stock Updates</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Stock Updates Management</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="text-end mb-4">
			<button @click="viewStockUpdateContentModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Content
			</button>
		</div>
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<!-- <div class="input-group">
						<div class="input-group-prepend"><span class="input-group-text">Category</span></div>
						<select v-model="membership_level" class="form-select">
							<option value="ALL">ALL</option>
							<option value="SILVER">SILVER</option>
							<option value="GOLD">GOLD</option>
							<option value="DIAMOND">DIAMOND</option>
							<option value="PLATINUM">PLATINUM</option>
						</select>
					</div> -->
				</div>
			</div>
			<div class="block-content block-content-full">
				<!-- Pagination -->
				<pagination v-if="stock_updates.data.length > 0" :collections="stock_updates"/>
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-hover table-vcenter">
						<thead>
							<tr>
								<th>TITLE</th>
								<th>IMAGE</th>
								<th>STATUS</th>
								<th nowrap="">DATE START</th>
								<th nowrap="">PUBLISHED DATE</th>
								<th>CREATED</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(stock_update, a_index) in stock_updates.data"
								:key="stock_update.stock_update_uuid"
							>
								<td>{{stock_update.stock_title}}</td>
								<td>
									<img :src="stock_update.stock_image_url" style="width: 50%" />
								</td>
								<td>
									<span v-if="stock_update.is_active==0" class="text-danger">OFF</span>
									<span v-if="stock_update.is_active==1" class="text-success">ON</span>
								</td>
								<td>{{stock_update.date_start_format}}</td>
								<td>{{stock_update.date_published_format}}</td>
								<td>{{stock_update.created_at_format}}</td>
								<td class="text-end">
									<button @click="viewStockUpdateContentModal(a_index,'update')" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-pencil-alt"></i></button>
									<button @click="confirmDelete(a_index)" type="button" class="btn btn-sm btn-alt-danger"><i class="fa fa-trash-alt"></i></button>
								</td>
							</tr>
							<tr v-if="stock_updates.data.length <= 0">
								<td colspan="7" class="mb-0 fw-semibold text-center p-5">NO STOCK UPDATES CONTENT FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="stock_updates.data.length > 0" :collections="stock_updates"/>
			</div>
		</div>
		<add-update-stock-update-content-modal ref="addUpdateStockUpdateContentModal" />

		<modal ref="modalDelete" size="modal-lg">
			<template #title>DELETE CONFIRM</template>
			<template #body>
				<p>Are you sure, you want to delete this content?</p>
			</template>
			<template #footer>
				<button 
					@click="deleteStockUpdate"
					type="submit"
					class="btn btn-alt-danger"
					:disabled="formDelete.processing"
				>
					<span v-if="!formDelete.processing"><i class="fa fa-check me-2"></i>Yes</span>
						<span v-else>
							<div class="spinner-border spinner-border-sm text-dark" role="status" >
								<span class="sr-only mr-1">Please wait...</span>
							</div>
							<span class="mx-2">Please wait...</span>
						</span>
				</button>
				<button
					@click="modalDelete.toggleModal"
					type="button"
					class="btn btn-alt-secondary"
					:disabled="formDelete.processing"
				>
					<i class="fa fa-times me-2"></i>NO
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';
import AuthLayout from '../../Layouts/AuthLayout';
import AddUpdateStockUpdateContentModal from '../../Components/Admin/AddUpdateStockUpdateContentModal';
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		stock_updates		: Object,
		api_response 		: Object
	},
	components:{AddUpdateStockUpdateContentModal},
	setup(props) {

		const action = ref('add');

		const toast = createToaster();

		const selectedStockUpdateContent = reactive({});

		const formDelete = useForm({
			stock_update_uuid 	: null,
			stock_image 		: null
		});

		const modalDelete 						= ref(null);
		const addUpdateStockUpdateContentModal 	= ref(null);

		const viewStockUpdateContentModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedStockUpdateContent.stock_update_uuid 		= props.stock_updates.data[_index].stock_update_uuid;
				selectedStockUpdateContent.category 				= props.stock_updates.data[_index].category;
				selectedStockUpdateContent.stock_title 				= props.stock_updates.data[_index].stock_title;
				selectedStockUpdateContent.stock_tags 				= props.stock_updates.data[_index].stock_tags;
				selectedStockUpdateContent.short_desc 				= props.stock_updates.data[_index].short_desc;
				selectedStockUpdateContent.stock_desc 				= props.stock_updates.data[_index].stock_desc;
				selectedStockUpdateContent.prev_stock_image 		= props.stock_updates.data[_index].prev_stock_image;
				selectedStockUpdateContent.stock_image 				= props.stock_updates.data[_index].stock_image;
				selectedStockUpdateContent.stock_image_url 			= props.stock_updates.data[_index].stock_image_url;
				selectedStockUpdateContent.is_active 				= props.stock_updates.data[_index].is_active;
				selectedStockUpdateContent.date_start 				= props.stock_updates.data[_index].date_start;
				selectedStockUpdateContent.date_published 			= props.stock_updates.data[_index].date_published;
			}

			addUpdateStockUpdateContentModal.value.setStockUpdateContent(_action,selectedStockUpdateContent);

			addUpdateStockUpdateContentModal.value.toggleModal();

		}

		const confirmDelete = (_index)=>{
			formDelete.stock_update_uuid 	=  props.stock_updates.data[_index].stock_update_uuid;
			formDelete.stock_image 			=  props.stock_updates.data[_index].stock_image;
			modalDelete.value.toggleModal();
		}

		const deleteStockUpdate = ()=>{
			action.value = 'delete';
			formDelete.delete('stock-updates/'+formDelete.stock_update_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['stock_updates,api_response'],
				onSuccess: () => {
					formDelete.reset();
					modalDelete.value.toggleModal();
				},
			})
		}

		// watch(membership_level, (value,old_value) => {
			
		// 	if(value!=old_value)
		// 	{
		// 		var param = {membership_level:value}

		// 		if(value=="null")
		// 		{
		// 			param = "";
		// 		}

		// 		Inertia.get(
		// 				'/admin/stock-updates', param,
		// 				{
		// 					// replace: true,
		// 					preserveState: true,
		// 					preserveScroll: true,
		// 					only: ['stock_updates']
		// 				}
		// 			)
		// 	}
		// })

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'added' : (action.value=='delete' ? 'deleted' : 'updated');

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "danger"});
				}
			}
		})

		return{
			toast,
			action,
			formDelete,
			modalDelete,
			confirmDelete,
			deleteStockUpdate,
			selectedStockUpdateContent,
			viewStockUpdateContentModal,
			addUpdateStockUpdateContentModal
		}
	},
}
</script>
